import { useFetch } from "../../../lib/useFetch";

export const GRP_JAPI_ANALYST_AUTOCOMPLETE_URL = "/research/japi/pub/search/autocomplete/category/analyst/";
export const GRP_JAPI_COMPANY_AUTOCOMPLETE_URL = "/research/japi/pub/search/autocomplete/category/company/";
export const GRP_JAPI_COUNTRY_AUTOCOMPLETE_URL = "/research/japi/pub/search/autocomplete/category/country/";
export const GRP_JAPI_PERIODICALS_AUTOCOMPLETE_URL = "/research/japi/pub/search/autocomplete/category/periodical/";
export const GRP_JAPI_REGION_AUTOCOMPLETE_URL = "/research/japi/pub/search/autocomplete/category/region/";

const urlMap = {
  analyst: GRP_JAPI_ANALYST_AUTOCOMPLETE_URL,
  company: GRP_JAPI_COMPANY_AUTOCOMPLETE_URL,
  country: GRP_JAPI_COUNTRY_AUTOCOMPLETE_URL,
  region: GRP_JAPI_REGION_AUTOCOMPLETE_URL,
};

export const useSuggestions = (query, filter, tags = []) => {
  const [results] = useFetch(urlMap[filter], JSON.stringify({ filter: query }));
  return (results.length || results.suggest) && filter ? parse(results, filter, tags) : [];
};

const parse = (results, filter, tags = []) => {
  const selected = tags.map((t) => t.id);
  if (!results || !results.suggest.autocomplete[0].options) return [];
  const queryResults = results.suggest.autocomplete[0].options.map((el) => el._source);
  return queryResults
    .filter((r) => r.category === filter && !selected.includes(r.name))
    .map((s) => ({ id: s.name, name: s.name, lang: s.language }));
};
